// ---------------------
// Article List Model ==
// ---------------------

import BCollection from './base/BCollection'
import Article from './Article'

export default class ArticleListing extends BCollection {

  bOptions() {
    return {
      model: Article,
      remoteModel: 'articles'
    }
  }

  routes() {
    return {
      fetch: '/api/articles/?l={listing}&q={query}&p={current_page}&r={current_rows}'
    }
  }

  defaults() {
    return {
      ...this.paginationFields
    }
  }
}
